<template>
  <div>
    <div class="eventEvaluation">
      <div v-if="eventInfo.currentLink === 8 && curRole === '县中心管理人员'">
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
          <FormItem label="上传图片">
            <Upload
              :headers="annexHeaders"
              :on-success="imagePathSuccess"
              multiple
              type="drag"
              accept="image/*"
              :show-upload-list="false"
              :action="$uploadUrl+'/api/file/uploadToLocal'">
              <div style="padding: 20px 0">
                <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                <p>点击或拖曳上传</p>
              </div>
            </Upload>
            <p style="width: 100%;display: inline-block" v-for="(item,index) in formValidate.eventCheckImg"
               :key="index">
              <span
                style="width: 80%;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;display: inline-block">{{
                  item
                }}</span>
              <Icon type="ios-close" style="float: right;font-size: 20px"
                    @click="delImagePath(index)"/>
            </p>
          </FormItem>
          <FormItem label="处置意见">
            <Input v-model="formValidate.eventCheck" type="textarea" :autosize="{minRows: 3}"
                   placeholder="请填写处置意见"></Input>
          </FormItem>
          <FormItem label="相关评估内容" prop="evaluationContent">
            <Input v-model="formValidate.evaluationContent" type="textarea" :autosize="{minRows: 5}"
                   placeholder="请填写相关评估内容"></Input>
            <span style="color: #ed3f14">评估内容：通过多长时间使用机械设备物料，出动人员达到什么目标，现场公路设施</span>
          </FormItem>
        </Form>
        <div style="text-align: center">
          <Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
          <Button @click="handleReset('formValidate')" style="margin-left: 8px">重置</Button>
        </div>
      </div>
      <div v-else>
        <el-descriptions class="margin-top" size="medium" :column="1" border
                         :labelStyle="{'text-align': 'center','width':'20%','color':'#555'}">
          <el-descriptions-item label="现场图片">
            <el-image v-for="(item,index) in formValidate.eventCheckImg.split(',')" alt="" :src="item"
                      :key="index"></el-image>
          </el-descriptions-item>
          <el-descriptions-item label="评估内容">
            {{ formValidate.eventCheck }}
          </el-descriptions-item>
          <el-descriptions-item label="处置意见">
            {{ formValidate.evaluationContent }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "eventEvaluation",
  props: {
    eventInfo: {
      type: Object,
      default: () => {
      }
    },
    stepInfo: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      annexHeaders: {Authorization: localStorage.getItem('token')},
      showPic: false,
      selectPic: {},
      formValidate: {
        evaluationContent: '',
        eventCheck: '',
        eventCheckImg: []
      },
      ruleValidate: {
        evaluationContent: [
          {required: true, message: '必填', trigger: 'blur'}
        ],
      },
      curRole: ''
    }
  },
  // watch: {
  //   userInfo: {
  //     immediate: true,
  //     deep: true,
  //     handler(newVal) {
  //       if (newVal) {
  //         console.log(newVal)
  //         this.curRole = newVal.roleNames
  //       }
  //     }
  //   }
  // },
  // computed: {
  //   userInfo: {
  //     get: function () {
  //       return this.$store.state.user.userInfo
  //     },
  //     set: function () {
  //     }
  //   }
  // },
  mounted() {
    this.getUserData()
    if (this.stepInfo !== '' && this.stepInfo !== null) {
      this.formatInfo()
      this.formatInfoEventCheckImg()
    }
  },
  methods: {
    imagePathSuccess(response, file, fileList) {
      console.log(response, file, fileList)
      let fileInfo = response.split(', ')
      let filePath = fileInfo[3].slice(0, -2)
      this.formValidate.eventCheckImg.push(filePath.split('=')[1])
    },
    delImagePath(index) {
      this.formValidate.eventCheckImg.splice(index, 1)
    },
    getUserData() {
      this.$http.get('/api/system/cscpCurrentUserDetails').then(res => {
        console.log(res)
        if (res.status === 200) {
          this.curRole = res.data.roleNames
        }
      })
    },
    formatInfoEventCheckImg() {
      console.log(this.stepInfo)
      let info = this.stepInfo.split(';')
      // console.log(info)
      info.forEach(item => {
        const obj = item.split('_')
        this.formValidate[obj[0]] = obj[1]
        if (obj[0] === 'eventCheckImg') {
          if (obj[1] === '[]') {
            this.formValidate.eventCheckImg = []
          } else {
            let str = ''
            for (let i = 1; i <= obj.length - 1; i++) {
              str = str + obj[i]
            }
            let list = JSON.parse(str)
            list = list.map(item => {
              return item.url
            })
            this.formValidate.eventCheckImg = list
          }
          // console.log(this.formValidate.eventCheckImg)
        }
      })
    },
    formatInfo() {
      let info = this.stepInfo.split('_')
      this.formValidate.evaluationContent = info[1]
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          // this.$Message.success('Success!');
          let params = {
            currentLink: this.eventInfo.currentLink,
            indexCode: this.eventInfo.deptIndexCode,
            information: `evaluationContent_${this.formValidate.evaluationContent};eventCheck_${this.formValidate.eventCheck};eventCheckImg_${this.formValidate.eventCheckImg};`,
            messageId: this.eventInfo.id
          }
          // console.log(params)
          this.$http.post('/api/jumpNextLink', params).then(res => {
            console.log(res)
            this.$emit('refreshStep')
          })
          this.$Message.success('提交成功!');
        } else {
          this.$Message.error('请填写!');
        }
      })
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    }
  }
}
</script>

<style scoped lang="less">
.eventEvaluation {
  width: 60%;
  margin: 0 auto;
}
</style>
